export default __webpack_public_path__ + "static/media/ads4.cbe60f2b.jpg";